<span class="mat-body-medium text-neutral-600">
  @for (tag of header.tags; track tag; let last = $last) {
    @if (tag.prefix) {
      <span>{{ tag.prefix }}</span>
    }
    <span [innerHTML]="tag.value"></span>
    @if (!last) {
      <span class="mr-1">;</span>
    }
  }
</span>
